import React from 'react';
import './LegalPages.css';

const TermsPage = () => {
  return (
    <div className="legal-page-wrapper">
      <header className="legal-header">
        <h1>Terms & Conditions</h1>
        <p>Effective as of August 6, 2025</p>
      </header>

      <main className="legal-page">
        <p>
          This document is an electronic record in terms of the Information Technology Act, 2000 and rules thereunder as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
        </p>

        <p>
          This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries Guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of the domain name <a href="https://redfox-digital.vercel.app/">https://redfox-digital.vercel.app/</a> (“Website”), including the related mobile site and mobile application (hereinafter referred to as the “Platform”).
        </p>

        <p>
          The Platform is owned by <strong>SAYED MOHAMMED NEHAL IBRAHIM</strong>, a company incorporated under the Companies Act, 1956 with its registered office at Bhubaneswar, Odisha, India (hereinafter referred to as "Platform Owner", “we”, “us”, “our”).
        </p>

        <p>
          Your use of the Platform and services and tools are governed by the following terms and conditions ("Terms of Use") as applicable to the Platform including the applicable policies which are incorporated herein by way of reference. If You transact on the Platform, You shall be subject to the policies that are applicable to the Platform for such transaction. By mere use of the Platform, You shall be contracting with the Platform Owner and these terms and conditions including the policies constitute Your binding obligations with Platform Owner.
        </p>

        <h3>1. User Responsibilities</h3>
        <ul>
          <li>You must provide true, accurate and complete information during and after registration.</li>
          <li>You are responsible for maintaining the confidentiality of your account and password.</li>
          <li>Unauthorized use of this Platform may give rise to a claim for damages and/or be a criminal offense.</li>
        </ul>

        <h3>2. Service Disclaimer</h3>
        <p>
          Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this Platform. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors.
        </p>

        <h3>3. Intellectual Property</h3>
        <p>
          All content on this Platform, including but not limited to design, layout, look, appearance, and graphics, is owned by or licensed to Redfox Digital. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
        </p>

        <h3>4. Third-Party Links</h3>
        <p>
          This Platform may include links to other websites. These links are provided for your convenience to provide further information. They do not signify that we endorse the website(s). We have no responsibility for the content of the linked website(s).
        </p>

        <h3>5. Limitation of Liability</h3>
        <p>
          In no event will Redfox Digital be liable for any direct, indirect, incidental, special, or consequential damages resulting from the use or the inability to use the Platform or services.
        </p>

        <h3>6. Charges</h3>
        <p>
          You agree to pay us the charges associated with availing the services as notified from time to time.
        </p>

        <h3>7. Force Majeure</h3>
        <p>
          Redfox Digital shall not be responsible for any delay or failure to comply with obligations under these terms if the delay or failure arises from any cause which is beyond our reasonable control.
        </p>

        <h3>8. Governing Law</h3>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of India. Any disputes relating to these terms and conditions shall be subject to the exclusive jurisdiction of the courts in Bhubaneswar, Odisha.
        </p>

        <h3>9. Contact</h3>
        <p>
          If you have any questions about these Terms, please contact us at <a href="mailto:redfoxdotin@gmail.com">redfoxdotin@gmail.com</a>.
        </p>
      </main>
    </div>
  );
};

export default TermsPage;
